import { getMessage } from '@tcc/i18n';
import styles from '../../../../components/cards/cardAndPreview/cardAndPreview.css';
import { LocalizedValue } from '../../../../utils/processUnits';

interface PlantingRowProps {
  area?: LocalizedValue,
  population?: LocalizedValue,
}

export function PlantingRow({ area, population }: PlantingRowProps) {
  return (
    <div className={styles.spacedRow}>
      <div className={styles.column}>
        <div className={styles.value} data-test-id="area-planted">
          {area ? (
            <div>
              {area.q} <span className={styles.units}>{area.u}</span>
            </div>
          ) : (
            '---'
          )}
        </div>
        <h3>{getMessage('card.planting.planted')}</h3>
      </div>
      <div className={styles.column}>
        <div
          className={styles.value}
          data-test-id="planting-average-population"
        >
          {population ? (
            <div>
              {population.q}{' '}
              <span className={styles.units}>{population.u}</span>
            </div>
          ) : (
            '---'
          )}
        </div>
        <h3>{getMessage('card.planting.avgPopulation')}</h3>
      </div>
    </div>
  );
}
